import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from './logger.service';

/**
 * Service to manage global UI state (sidenav, modals, etc.)
 */
@Injectable({
  providedIn: 'root'
})
export class UiStateService {
  // Signal to control sidenav state globally
  private readonly _sidenavOpen = signal(false);

  readonly sidenavOpen = this._sidenavOpen.asReadonly();

  private router = inject(Router);
  private logger = inject(LoggerService).getLogger('nav-history');

  toggleSidenav(): void {
    if (this._sidenavOpen()) {
      this.closeSidenav();
    } else {
      this.openSidenav();
    }
  }

  openSidenav(): void {
    this.logger.debug('📂 Opening sidenav via query param');
    // Navigate to current route with ?n query param
    this.router.navigate([], {
      queryParams: { n: '1' },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  closeSidenav(): void {
    this.logger.debug('🚪 Closing sidenav via query param removal');
    // Navigate to current route without ?n query param
    this.router.navigate([], {
      queryParams: { n: null },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  // Internal method called by app component to sync state from query params
  setSidenavState(open: boolean): void {
    this._sidenavOpen.set(open);
  }
}
